module.exports = __webpack_public_path__ + "static/media/coding-lesson-for-kids.e253974f.webp";